import React, { useEffect, useRef, useState } from 'react';
import './Navbar.css';

export const Navbar = () => {
  const navRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('about');

  // Show/hide navbar based on scroll position
  useEffect(() => {
    const onScroll = () => {
      if (!navRef.current) return;
      
      if (window.scrollY > 300) {
        navRef.current.classList.remove('hidden');
      } else {
        navRef.current.classList.add('hidden');
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Active section detection
  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY + 200;
      const about = document.getElementById('about');
      const experience = document.getElementById('experience');
      const projects = document.getElementById('projects');
      
      if (projects && scrollY >= projects.offsetTop) {
        setActiveSection('projects');
      } else if (experience && scrollY >= experience.offsetTop) {
        setActiveSection('experience');
      } else if (about && scrollY >= about.offsetTop) {
        setActiveSection('about');
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close dropdown when any link is clicked (guard null)
  useEffect(() => {
    const container = navRef.current?.querySelector('.navlinks');
    if (!container) return;
    const handleClick = () => setOpen(false);
    container.addEventListener('click', handleClick);
    return () => container.removeEventListener('click', handleClick);
  }, []);

  // Close menu on resize
  useEffect(() => {
    const handleResize = () => setOpen(false);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav ref={navRef} className={`navbar${open ? ' open' : ''}`}>
      <button 
        className="top-left-name"
        onClick={() => {
          const about = document.getElementById('about');
          if (about) about.scrollIntoView({ behavior: 'smooth' });
        }}
      >
        <h1>SL</h1>
      </button>

      <button
        className="nav-toggle"
        aria-label="Toggle navigation"
        onClick={() => setOpen(o => !o)}
      >
        <span />
        <span />
        <span />
      </button>

      <div className="navlinks">
        <button
          className={activeSection === 'about' ? 'nav-link active-link' : 'nav-link'}
          onClick={() => {
            const about = document.getElementById('about');
            if (about) about.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          about
        </button>

        <button
          className={activeSection === 'experience' ? 'nav-link active-link' : 'nav-link'}
          onClick={() => {
            const experience = document.getElementById('experience');
            if (experience) experience.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          experience
        </button>

        <button
          className={activeSection === 'projects' ? 'nav-link active-link' : 'nav-link'}
          onClick={() => {
            const projects = document.getElementById('projects-title');
            if (projects) projects.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          projects
        </button>
        <a
          href="https://www.linkedin.com/in/sharon-liangg/"
          target="_blank"
          rel="noopener noreferrer"
          className="connect-button"
        >
          connect
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
